/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-04-17 10:44:31
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-06-09 17:40:42
 * @FilePath: \lhao-pc\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createStore } from "vuex";

export default createStore({
  state: {
    activeName: "",
  },
  getters: {},
  mutations: {
    changeTabs(state, obj) {
      state.activeName = obj;
      // console.log(state.activeName);
    },
  },
  actions: {},
  modules: {},
});
